<template>
  <div>
    <v-layout>
      <ExportAccount :accountType="'invoice'" :headers="headers" />
    </v-layout>
    <v-data-table :headers="headers" :items="accountList" class="elevation-1" :mobile-breakpoint="0" :loading="loading"
      :options.sync="options" :items-per-page="25" :server-items-length="totalItemsCount"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }">
      <template v-slot:[`item.siNo`]="{ item }">
        {{
            accountList
              .map(function (x) {
                return x._id;
              })
              .indexOf(item._id) + 1 + variables.skip
        }}
      </template>
      <template v-slot:[`item.customerName`]="{ item }">
        <router-link v-if="item.user" :to="{
          name: 'CustomerDetails',
          params: { customerId: item.customer },
          query: { customerId: item.customer }
        }" class="mx-auto">
          {{ capitalizeFirstLetter(item.user.firstnameEn) }}
          {{ capitalizeFirstLetter(item.user.lastnameEn) }}
        </router-link>
      </template>
      <template v-slot:[`item.contact`]="{ item }">
        <span v-if="item.user">
          {{ item.user.phone }}
        </span>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ dateFormat(new Date(parseInt(item.createdAt))) }}
      </template>
      <template v-slot:[`item.amount`]="{ item }">
        {{ numberWithCommas(item.amount) }}
      </template>
      <template v-slot:[`item.discount`]="{ item }">
        {{ numberWithCommas(item.discount) }}
      </template>
      <template v-slot:[`item.taxes`]="{ item }">
        {{ numberWithCommas(item.tax) }}
      </template>
      <template v-slot:[`item.total`]="{ item }">
        {{ numberWithCommas(item.total) }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <InvoiceDownload :invoice="item" type="invoice" />
      </template>
    </v-data-table>
  </div>
</template>
<script>
import moment from "moment";
import InvoiceDownload from "../components/InvoiceDownload.vue";
import ExportAccount from "./ExportAccount.vue";
export default {
  components: {
    InvoiceDownload,
    ExportAccount
  },
  data: () => ({
    accountList: [],
    totalItemsCount: 0,
    loading: true,
    headers: [
      {
        text: "Si No",
        value: "siNo"
      },
      { text: "Customer Name", value: "customerName" },
      { text: "Contact", value: "contact" },
      { text: "Date and Time", value: "date" },
      { text: "Amount", value: "amount" },
      { text: "Discount", value: "discount" },
      { text: "Tax", value: "taxes" },
      { text: "Total ", value: "total" },
      { text: "Action ", value: "action" }
    ],
    variables: {
      limit: 25,
      skip: 0
    },
    options: {
      itemsPerPage: 25,
      page: 1
    },
  }),
  watch: {
    options: {
      handler() {
        if (!this.loading) {
          this.variables.limit = this.options.itemsPerPage;
          this.variables.skip =
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage;

          this.getAllInvoiceTransaction();
        }
      },
      deep: true
    }
  },
  created() {
    this.getAllInvoiceTransaction()
  },
  methods: {
    dateFormat(date) {
      return moment(date, "MM-DD-YYYY").format("DD-MM-YYYY, h:mm:ss A");
    },
    getAllInvoiceTransaction() {
      console.log(this.variables);
      this.$apollo
        .query({
          query: require("../api/getAllInvoiceTransaction.graphql"),
          variables: this.variables
        })
        .then(data => {
          if (data.data) {
            this.accountList =
              data.data.getAllInvoiceTransactions.transactionList;
            // );
            console.log(this.accountList.length)
            this.totalItemsCount =
              data.data.getAllInvoiceTransactions.totalCount;
            this.loading = false;
          }
        });
    },
  }
};
</script>
